// Scroll-Video der Licht-Sektion (iconRow).
// Figma: Der Sektions-Hintergrund ist ein Videostandbild ("Bildschirmfoto ...") —
// beim Herunterscrollen soll das Video erscheinen und abspielen. Das Standbild
// (CMS-Hintergrundbild) bleibt als Poster darunter liegen; das Video blendet
// per Opacity darüber ein, sobald es spielt (Klasse `is-playing`).
//
// - Quelle: CMS-Videoelement (Sitepart "Mediengalerie Videos", Wrapper
//   .js-iconRowVideo um das <video>).
// - Mobil-/Desktop-Video: Das Videoelement rendert je Variante ein
//   <source media="(min-width:…)">. Der Browser wertet das nur einmal beim Laden
//   aus (und ignoriert unbekannte type-Angaben wie video/mov) — wir wählen die
//   Quelle deshalb selbst per matchMedia und wechseln beim Breakpoint.
// - Playback startet erst, wenn die Sektion im Viewport ist, und pausiert
//   außerhalb (spart Akku/Bandbreite). Ein im CMS gesetztes Autoplay wird
//   deshalb entfernt.
// - data-start (Sekunden): Video beginnt an dieser Stelle und springt bei jedem
//   Loop-Durchlauf wieder dorthin (blendet z. B. einen unsauberen Videoanfang aus).
// - prefers-reduced-motion: Video bleibt aus, das Standbild genügt.
// - Autoplay-sicher: muted + playsinline werden erzwungen.

function resolveVideo(el) {
  return el.tagName === 'VIDEO' ? el : el.querySelector('video');
}

function bindResponsiveSources(video) {
  const sources = Array.from(video.querySelectorAll('source[src]'));
  const queries = sources
    .filter((source) => source.media)
    .map((source) => window.matchMedia(source.media));
  if (!queries.length) {
    return;
  }

  const pick = () => {
    const matching = sources.filter((source) => !source.media || window.matchMedia(source.media).matches);
    const candidates = matching.length ? matching : sources;
    return candidates.find((source) => !source.type || video.canPlayType(source.type) !== '') || candidates[0];
  };

  const apply = () => {
    const src = pick().getAttribute('src');
    if (video.getAttribute('src') === src) {
      return;
    }
    const wasPlaying = !video.paused;
    video.src = src;
    video.load();
    if (wasPlaying) {
      video.play().catch(() => {});
    }
  };

  apply();
  queries.forEach((query) => query.addEventListener('change', apply));
}

function applyStartOffset(video, start) {
  if (!(start > 0)) {
    return;
  }

  const seek = () => {
    if (video.duration && start < video.duration) {
      video.currentTime = start;
    }
  };

  if (video.readyState >= 1) {
    seek();
  }
  video.addEventListener('loadedmetadata', seek);

  // Loop selbst steuern, damit jeder Durchlauf ab dem Startpunkt beginnt
  if (video.loop) {
    video.loop = false;
    video.addEventListener('ended', () => {
      video.currentTime = start;
      video.play().catch(() => {});
    });
  }
}

export function initIconRowVideo() {
  const wrappers = document.querySelectorAll('.js-iconRowVideo');
  if (!wrappers.length) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const entries = [];
  wrappers.forEach((wrapper) => {
    const video = resolveVideo(wrapper);
    if (!video) {
      return;
    }
    video.removeAttribute('autoplay');
    video.autoplay = false;
    video.pause();
    video.muted = true;
    video.playsInline = true;
    bindResponsiveSources(video);
    applyStartOffset(video, parseFloat(wrapper.dataset.start || '0'));
    entries.push({ wrapper, video });
  });

  const start = ({ wrapper, video }) => {
    const playing = video.play();
    if (playing !== undefined) {
      playing
        .then(() => wrapper.classList.add('is-playing'))
        .catch(() => { /* Autoplay blockiert -> Standbild bleibt sichtbar */ });
    }
  };

  if (!('IntersectionObserver' in window)) {
    entries.forEach(start);
    return;
  }

  const byWrapper = new Map(entries.map((entry) => [entry.wrapper, entry]));
  const observer = new IntersectionObserver((observed) => {
    observed.forEach((item) => {
      const entry = byWrapper.get(item.target);
      if (item.isIntersecting) {
        start(entry);
      } else if (!entry.video.paused) {
        entry.video.pause();
      }
    });
    // Grosszuegiger Vorlauf (~1 Viewporthoehe): Das Video startet bereits,
    // waehrend darueber die Licht-Choreografie (lightFontAnimation) laeuft —
    // beim Weiterscrollen laeuft es nahtlos durch statt erst anzuspringen.
  }, { rootMargin: '100% 0px' });

  entries.forEach(({ wrapper }) => observer.observe(wrapper));
}
